module.exports = __webpack_public_path__ + "static/media/blog-blogger-bloglovin-svgrepo-com.a9b379bd.svg";